<template>
	<v-dialog
		v-model="show"
		scrollable
		width="1024px">
		<v-card v-if="asset" class="background">
			<v-card-title class="px-2 py-1 title">
				{{ asset.ref_material }} | {{ asset.id }}
				<v-spacer></v-spacer>
				<v-btn
					flat icon
					@click="asset = null; show = false"
					class="ma-0">
					<v-icon>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="background darken-1 pa-0">
				<Asset :asset="asset" :tab="tab">
				</Asset>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import Asset from '@/components/asset.vue'
export default {
	components: { Asset },
	data () {
		return {
			show: false,
			tab: null,
			asset: null
		}
	},
	mounted () {
		this.$Bus.$on('show-asset-modal', (msg) => {
			this.asset = msg.asset
			this.tab = msg.tab
			this.show = true
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/globals/modal_asset.vue